module.exports = __webpack_public_path__ + "static/media/phonics_02.374b0128.jpg";